<template>
    <v-layout justify-center>
        <v-responsive width="100%" max-width="640" height="100%" class="mx-n3 px-3">
            <list-heading title="생산보고서 목록" />

            <v-card outlined class="mt-4" style="overflow: hidden">
                <v-data-table v-bind="{ loading, headers, items }" disable-sort disable-pagination hide-default-footer :items-per-page="-1" @click:row="openItem">
                    <template v-for="header in headers.filter((header) => header.hasOwnProperty('formatter'))" v-slot:[`item.${header.value}`]="{ value }"> {{ header.formatter(value) }} </template>
                </v-data-table>
            </v-card>
            <v-pagination :value="page" :length="pageCount" :total-visible="11" class="mt-4 mx-4" @input="(page) => $router.push({ query: { ...$route.query, page } })"></v-pagination>
        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";
import { attrs_input, initDataTableHeaders } from "@/assets/variables";

import ListHeading from "@/components/console/dumb/list-heading.vue";

const headers = initDataTableHeaders([
    { text: "#", value: "index", width: +60, align: "end" },
    { text: "작업공정", value: "PROCESS" },
    { text: "계획일자", value: "PLAN_DATE" },
]);

export default {
    components: {
        ListHeading,
    },
    data: () => ({
        reports: [],

        limit: 10,
        summary: { totalCount: 0 },

        loading: false,
        headers,
        attrs_input,
    }),
    computed: {
        items() {
            return this.reports.map((item, index) => ({ ...item, index: this.summary.totalCount - (this.page - 1) * this.limit - index }));
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { ...query } = this.$route.query;

            return { ...query };
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        params() {
            this.search();
        },
    },
    methods: {
        async init() {
            try {
                this.search();
            } catch (error) {
                console.error(error);
            }
        },

        async search() {
            if (this.loading) return;
            else this.loading = true;
            try {
                let { skip, limit, params } = this;
                var { summary, reports } = await api.console.mes.reports.gets({
                    headers: { skip, limit },
                    params,
                });

                this.reports = reports;
                this.summary = summary;
            } catch (error) {
                console.error(error);
            } finally {
                this.loading = false;
            }
        },

        openItem(item) {
            const { PROCESS, PLAN_DATE } = item;
            this.$router.push(`${this.$route.path}/${PROCESS}/${PLAN_DATE}`);
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .line-height-1-5 {
        line-height: 1.5;
    }
    .max-width-0 {
        max-width: 0;
    }
    .word-break-keep-all {
        word-break: keep-all;
    }
    .white-space-pre-line {
        white-space: pre-line;
    }
    .cursor-pointer {
        cursor: pointer;
    }
    .v-pagination button {
        box-shadow: none !important;
        border: thin solid rgba(0, 0, 0, 0.12);
    }
    .v-small-dialog__activator {
        height: 100%;
    }
    .v-small-dialog__activator__content {
        width: 100%;
    }

    th:first-of-type:not(:last-of-type),
    td:first-of-type:not(:last-of-type) {
        border-right: thin solid rgba(0, 0, 0, 0.12);
    }

    .v-data-table__expanded__content {
        box-shadow: none !important;
    }
    .vertical-align-top {
        vertical-align: top !important;
    }

    .v-data-table tr td {
        cursor: pointer !important;
    }
}
</style>
